// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3be22108","455":"47b9b92c","977":"8e924ab4"}[chunkId] + ".chunk.js";
};